/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Faq_A2Inputs */

const en_pc_dl_faq_a2 = /** @type {(inputs: Pc_Dl_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The .msi installs for all users and needs administrator rights. Without them, use the portable .zip: it runs from any folder, even a USB stick, and keeps its settings in a PdfCraftData folder next to pdfcraft.exe.`)
};

const zh_pc_dl_faq_a2 = /** @type {(inputs: Pc_Dl_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.msi 会为所有用户安装，需要管理员权限。没有管理员权限时请使用便携 .zip：它可以在任意文件夹甚至 U 盘中运行，设置保存在 pdfcraft.exe 旁边的 PdfCraftData 文件夹里。`)
};

/**
* | output |
* | --- |
* | "The .msi installs for all users and needs administrator rights. Without them, use the portable .zip: it runs from any folder, even a USB stick, and keeps its..." |
*
* @param {Pc_Dl_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_faq_a2 = /** @type {((inputs?: Pc_Dl_Faq_A2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Faq_A2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_faq_a2(inputs)
	return zh_pc_dl_faq_a2(inputs)
});
export { pc_dl_faq_a2 as "pc.dl.faq.a2" }